import type { Locale } from '@/intl/types'
import type groupResponsibleAPIClient from '@/scopes/account/group-responsible/infrastructure/groupResponsibleAPIClient'
import type { groupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/store'
import type QsClient from '@/scopes/common/infrastructure/query-strings/queryStringClient'

function groupResponsibleUseCases({
  apiClient,
  store,
  queryStringClient,
  locale,
}: {
  apiClient: typeof groupResponsibleAPIClient
  store: typeof groupResponsibleStore
  queryStringClient: typeof QsClient
  locale?: Locale
}) {
  async function pageLoaded() {
    const masterBookingNumber = queryStringClient.getValue('bookingNumber')
    let data
    const state = store.getState()
    state.setIn('retrieveBookingData.loading', true)
    try {
      data = await apiClient.getGroupBookingData(masterBookingNumber || '', locale)
      if (!data) {
        state.setIn('retrieveBookingData', { loading: false, error: true })
        return
      }
    }
    catch {
      state.setIn('retrieveBookingData', { loading: false, error: true })
      return
    }
    state.setIn('retrieveBookingData.loading', false)

    state.initialize({
      bookingData: {
        group: {
          name: data?.group.name ?? '',
          imgSrc: data?.group.imgSrc ?? '',
          location: data?.group.location ?? '',
          period: data?.group.period ?? '',
        },
        labels: data?.labels,
      },
      participants: data?.participants,
      rooms: data?.rooms,
      buses: data?.buses,
    })
  }
  return { pageLoaded }
}

export default groupResponsibleUseCases
